<script lang="ts" setup>
import SFButton from '@/components/ui/button/Button.vue'
import Dropdown from '@/components/ui/dropdown/Dropdown.vue'
import { inject, ref } from 'vue'
import { FireRiskDashboardViewModel } from '../viewmodels/FireRiskDashboard.viewmodel'
import DataPicker from '@/components/ui/dataPicker/DataPicker.vue'
import { FireRiskEnum } from '@/@core/fire-risk-dashboard/domain/enum/FireRisk.enum'
import { FireOutbreakOccurrenceEnum } from '@/@core/fire-risk-dashboard/domain/enum/FireOutbreakOccurence.enum'
import { FireOutbreakReactionEnum } from '@/@core/fire-risk-dashboard/domain/enum/FireOutbreakReaction.enum'
import { FireAlertsFilterDto } from '../dtos/FireAlertsFilter.dto'
import { onClickOutside } from '@vueuse/core'

defineProps<{
	disabled: boolean
}>()

const filter = ref()

const vm = inject<FireRiskDashboardViewModel>('fire-risk-dashboard-viewmodel')!

const fireAlertsFilter = ref<FireAlertsFilterDto>({ ...vm.initFireAlertsFilter })

const isFileringOpen = ref(false)

const riskTypes = [
	{ label: 'Nulo', value: FireRiskEnum.NONE },
	{ label: 'Pequeno', value: FireRiskEnum.SMALL },
	{ label: 'Médio', value: FireRiskEnum.MEDIUM },
	{ label: 'Alto', value: FireRiskEnum.HIGH },
	{ label: 'Muito Alto', value: FireRiskEnum.HIGHEST },
]

const occurrence = [
	{ label: 'Fazenda', value: FireOutbreakOccurrenceEnum.FARM },
	{ label: 'Buffer', value: FireOutbreakOccurrenceEnum.BUFFER },
]

const reactions = [
	{ label: 'Positivo', value: FireOutbreakReactionEnum.POSITIVE },
	{ label: 'Negativo', value: FireOutbreakReactionEnum.NEGATIVE },
	{ label: 'Indeterminado', value: FireOutbreakReactionEnum.IMPOSSIBLE },
	{ label: 'Sem avaliação', value: undefined },
]

function setFilter() {
	vm.fireAlertsFilter.value = { ...fireAlertsFilter.value }
	closeFilter()
}

function clearFilter() {
	fireAlertsFilter.value = { ...vm.initFireAlertsFilter }
	vm.clearFilter()
	closeFilter()
}

function openFilter() {
	isFileringOpen.value = true
}

function closeFilter() {
	isFileringOpen.value = false
}

onClickOutside(filter, closeFilter)
</script>

<template>
	<div class="relative">
		<s-f-button
			class="h-full"
			icon="flowbite:filter-solid"
			secondary
			@click="openFilter"
			:disabled="disabled"
		/>
		<div
			ref="filter"
			v-show="isFileringOpen"
			class="bg-white-neutral border border-black-neutral rounded min-w-80 absolute z-10 p-3 flex flex-col gap-4 -translate-x-[102%] -translate-y-1/2"
		>
			<dropdown
				:options="vm.farms.value"
				v-model="fireAlertsFilter.farms"
				placeholder="Selecione"
				label="fazenda/setor"
			/>
			<div class="flex flex-col gap-1">
				<label class="text-label">Data</label>
				<data-picker
					:max-date="new Date().toISOString()"
					v-model="fireAlertsFilter.startDate"
				/>
				<data-picker
					:min-date="fireAlertsFilter.startDate"
					:max-date="new Date().toISOString()"
					v-model="fireAlertsFilter.endData"
				/>
			</div>
			<div class="flex flex-col">
				<label class="text-label text-center">confiança da detecção (%)</label>
				<div class="flex items-center gap-1 w-full">
					<span class="text-s-bold !text-blue-tints">{{
						fireAlertsFilter.detectionConfidence.at(0)
					}}</span>
					<v-range-slider
						v-model="fireAlertsFilter.detectionConfidence"
						color="#34617E"
						track-color="#34617E"
						max="100"
						min="0"
						hide-details
					/>
					<span class="text-s-bold !text-blue-tints">{{
						fireAlertsFilter.detectionConfidence.at(1)
					}}</span>
				</div>
			</div>
			<dropdown
				:options="riskTypes"
				v-model="fireAlertsFilter.risks"
				placeholder="Selecione"
				label="tipo de risco"
			/>
			<dropdown
				:options="occurrence"
				v-model="fireAlertsFilter.occurrences"
				label="local da ocorrência"
			/>
			<dropdown
				:options="reactions"
				v-model="fireAlertsFilter.reactions"
				label="avaliação do alerta"
			/>
			<div class="flex justify-between gap-4">
				<s-f-button
					text="limpar filtros"
					secondary
					class="w-1/2 justify-center"
					@click="clearFilter"
				/>
				<s-f-button
					text="filtrar"
					class="w-1/2 justify-center"
					@click="setFilter"
				/>
			</div>
		</div>
	</div>
</template>
